import React, { MouseEvent, useRef } from 'react';
import MarkReadUnreadBtn from './mark-read-unread-btn';
import ClearBtn from './clear-btn';
import { IStoreProps } from '../../../index';

interface IDotsMenuPanelProps {
    storeProps: IStoreProps;
}

const DotsMenuPanel = ({ storeProps }: IDotsMenuPanelProps) => {

    const { useAppSelector } = storeProps;

    const boxRef = useRef<HTMLDivElement>(null);

    const additionalOpenedMenuNotification = useAppSelector(store => store.root.additionalOpenedMenuNotification);
    const additionalOpenedMenuStyles = useAppSelector(store => store.root.additionalOpenedMenuStyles);

    const stopPropagation = (evt: MouseEvent) => {
        evt.stopPropagation();
    };

    return (
        <div ref={ boxRef } onClick={ stopPropagation }>
            {
                additionalOpenedMenuNotification &&
                <div
                    role="menu"
                    id={ `notification-menu-${ additionalOpenedMenuNotification.userNTFGUID }` }
                    className="absolute right-0 top-0 bg-white text-gray-500 shadow-md rounded text-tiny z-50 border border-gray-100 py-2"
                    style={ additionalOpenedMenuStyles || {} }>
                    <MarkReadUnreadBtn
                        storeProps={ storeProps }
                        notification={ additionalOpenedMenuNotification }
                    />
                    <div
                        className="bg-gray-100 w-full my-2"
                        style={{
                            height: '1px',
                        }}
                    />
                    <ClearBtn
                        storeProps={ storeProps }
                        notification={ additionalOpenedMenuNotification }
                    />
                </div>
            }
        </div>
    )
};

export default DotsMenuPanel;